import { useRevalidator } from 'react-router-dom';
import { useQueries } from '@tanstack/react-query';
import RecommendConceptsClient from '../../clientAPI/recommendConcepts';
import { QUERY_KEYS } from '../../constants';

export default function TriggerConcepts({
  conceptIds,
}: {
  conceptIds: string[];
}) {
  const revalidator = useRevalidator();
  const conceptQueries = conceptIds.map((id) => {
    const queryKey = [QUERY_KEYS.RECOMMEND_CONCEPT_BY_ID, id];
    const queryFn = () => RecommendConceptsClient.getConceptById(id);
    return {
      queryKey,
      queryFn,
      staleTime: Infinity,
      onError: (err: { status: number }) =>
        err.status === 401 && revalidator.revalidate(),
    };
  });
  const results = useQueries({ queries: conceptQueries });
  const isLoading = results.some((result) => result.isLoading);
  if (isLoading) return null;
  return <>[{results.map((res) => res.data?.name).join(', ')}]</>;
}
